import {
  CheckCircleFilled,
  FilterOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Tabs, Badge, Result } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import ApprovalActionApi from "../../api/approvals/ApprovalActionApi";
import { GetApprovalsApi } from "../../api/approvals/GetApprovalsApi";
import GetFilteredApprovalsApi from "../../api/approvals/getFilteredApprovalsApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import ApprovalsFilterModal from "../../components/modal/filters/ApprovalsFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import AllApprovalsTable from "../../components/tables/AllApprovalsTable";
import ApprovedApprovalsTable from "../../components/tables/ApprovedApprovalsTable";
import PendingApprovalsTable from "../../components/tables/PendingApprovalsTable";
import RejectedApprovalsTable from "../../components/tables/RejectedApprovalsTable";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { useSelector } from "react-redux";
import { LIMIT_PER_PAGE } from "../../helpers/constants";


const { TabPane } = Tabs;

function Approvals() {
  const [allData, setAllData] = useState("");
  const [pendingData, setPendingData] = useState("");
  const [approvedData, setApprovedData] = useState("");
  const [rejectedData, setRejectedData] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [allPage, setAllPage] = useState(1);
  const [pendingPage, setPendingPage] = useState(1);
  const [approvedPage, setApprovedPage] = useState(1);
  const [rejectedPage, setRejectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    setLoading(true);
    positionState?.id && getAllApprovals(allPage);

    setFilterBy({ type: "" });
  }, [positionState]);

  // get all data
  async function getAllApprovals(num) {
    setTableLoading(true);
    const apiResponse = await GetApprovalsApi(num, "", positionState?.id, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setAllData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }
  async function getPendingApprovals(num) {
    setTableLoading(true);
    const apiResponse = await GetApprovalsApi(
      num,
      "pending",
      positionState?.id, 
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setPendingData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }
  async function getApprovedApprovals(num) {
    const apiResponse = await GetApprovalsApi(
      num,
      "approved",
      positionState?.id, 
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setApprovedData(apiResponse?.data);
    }
    setLoading(false);
  }
  async function getRejectedApprovals(num) {
    const apiResponse = await GetApprovalsApi(
      num,
      "rejected",
      positionState?.id, 
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setRejectedData(apiResponse?.data);
    }
    setLoading(false);
  }

  // approve and reject
  async function approveApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await ApprovalActionApi(id, action);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (pendingData?.approvals?.length === 1) {
          const newPage = pendingPage === 1 ? pendingPage : pendingPage - 1;
          setPendingPage(newPage);
          changeTablePage(newPage);
        } else {
          changeTablePage(pendingPage);
        }
      } else if (from === "all") {
        if (allData?.approvals?.length === 1) {
          const newPage = allPage === 1 ? allPage : allPage - 1;
          setAllPage(newPage);
          changeTablePage(newPage);
        } else {
          changeTablePage(allPage);
        }
      }
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't approve. Try again later."
      );
    }
    setTableLoading(false);
  }
  async function rejectApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await ApprovalActionApi(id, action);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (pendingData?.approvals?.length === 1) {
          const newPage = pendingPage === 1 ? pendingPage : pendingPage - 1;
          setPendingPage(newPage);
          changeTablePage(newPage);
        } else {
          changeTablePage(pendingPage);
        }
      } else if (from === "all") {
        if (allData?.approvals?.length === 1) {
          const newPage = allPage === 1 ? allPage : allPage - 1;
          setAllPage(newPage);
          changeTablePage(newPage);
        } else {
          changeTablePage(allPage);
        }
      }
    } else {
      openNotificationError("bottomRight", "Couldn't reject. Try again later.");
    }
    setTableLoading(false);
    // setDisableAttributeId("");
  }

  // get filtered data
  async function getFilterAllApprovals(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredApprovalsApi(
      num,
      LIMIT_PER_PAGE,
      "",
      values.type || "",
      positionState?.id
    );

    if (apiResponse.success) {
      setAllData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }
  async function getFilterPendingApprovals(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredApprovalsApi(
      num,
      LIMIT_PER_PAGE,
      "Pending",
      values.type || "",
      positionState?.id
    );

    if (apiResponse.success) {
      setPendingData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }
  async function getFilterApprovedApprovals(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredApprovalsApi(
      num,
      LIMIT_PER_PAGE,
      "Approved",
      values.type || "",
      positionState?.id
    );

    if (apiResponse.success) {
      setApprovedData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }
  async function getFilterRejectedApprovals(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredApprovalsApi(
      num,
      LIMIT_PER_PAGE,
      "Rejected",
      values.type || "",
      positionState?.id
    );

    if (apiResponse.success) {
      setRejectedData(apiResponse?.data);
    }
    setLoading(false);
    setTableLoading(false);
  }

  function changeTablePage(num) {
    if (selectedTab === "all") {
      setAllPage(num);
      if (filterStatus) {
        getFilterAllApprovals(filterBy, num);
      } else {
        getAllApprovals(num);
      }
    } else if (selectedTab === "pending") {
      setPendingPage(num);
      if (filterStatus) {
        getFilterPendingApprovals(filterBy, num);
      } else {
        getPendingApprovals(num);
      }
    } else if (selectedTab === "approved") {
      setApprovedPage(num);
      if (filterStatus) {
        getFilterApprovedApprovals(filterBy, num);
      } else {
        getApprovedApprovals(num);
      }
    } else if (selectedTab === "rejected") {
      setRejectedPage(num);
      if (filterStatus) {
        getFilterRejectedApprovals(filterBy, num);
      } else {
        getRejectedApprovals(num);
      }
    }
  }

  function filterApproval(values, num) {
    setFilterStatus(true);
    setFilterBy({
      type: values.type,
    });
    if (selectedTab === "all") {
      setAllPage(num);
      getFilterAllApprovals({ type: values.type }, num);
    } else if (selectedTab === "pending") {
      setPendingPage(num);
      getFilterPendingApprovals({ type: values.type }, num);
    } else if (selectedTab === "approved") {
      setApprovedPage(num);
      getFilterApprovedApprovals({ type: values.type }, num);
    } else {
      setRejectedPage(num);
      getFilterRejectedApprovals({ type: values.type }, num);
    }
  }

  function changeTab(key) {
    setLoading(true);
    if (key === "1") {
      setSelectedTab("all");
      filterStatus
        ? getFilterAllApprovals(filterBy, allPage)
        : getAllApprovals(allPage);
    } else if (key === "2") {
      setSelectedTab("pending");
      filterStatus
        ? getFilterPendingApprovals(filterBy, pendingPage)
        : getPendingApprovals(pendingPage);
    } else if (key === "3") {
      setSelectedTab("approved");
      filterStatus
        ? getFilterApprovedApprovals(filterBy, approvedPage)
        : getApprovedApprovals(approvedPage);
    } else if (key === "4") {
      setSelectedTab("rejected");
      filterStatus
        ? getFilterRejectedApprovals(filterBy, rejectedPage)
        : getRejectedApprovals(rejectedPage);
    }
  }

  function getAllData(num) {
    if (selectedTab === "all") {
      setAllPage(num);
      getAllApprovals(num);
    } else if (selectedTab === "pending") {
      setPendingPage(num);
      getPendingApprovals(num);
    } else if (selectedTab === "approved") {
      setApprovedPage(num);
      getApprovedApprovals(num);
    } else if (selectedTab === "rejected") {
      setRejectedPage(num);
      getRejectedApprovals(num);
    }
  }

  function resetFilter() {
    if (selectedTab === "all") {
      setAllPage(1);
      getAllApprovals(1);
    } else if (selectedTab === "pending") {
      setPendingPage(1);
      getPendingApprovals(1);
    } else if (selectedTab === "approved") {
      setApprovedPage(1);
      getApprovedApprovals(1);
    } else if (selectedTab === "rejected") {
      setRejectedPage(1);
      getRejectedApprovals(1);
    }
    setFilterStatus(false);
    setFilterBy();
  }

  const right = (
    <>
      <Tooltip title={"Reset"}>
        <Button
          disabled={!filterStatus}
          onClick={() => resetFilter()}
          className="mr-3"
        >
          <UndoOutlined />
        </Button>
      </Tooltip>
      <Tooltip title={"Filter"}>
        <Badge
          count={
            filterStatus ? (
              <CheckCircleFilled style={{ color: "#f5222d" }} />
            ) : (
              0
            )
          }
        >
          <Button onClick={() => setFilterModal(true)}>
            <FilterOutlined />
          </Button>
        </Badge>
      </Tooltip>
    </>
  );

  const left = <div className="pri-font text-lg">Approvals</div>;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs onChange={changeTab} defaultActiveKey="1" centered>
            <TabPane tab={<div className="w-32 text-center ">All</div>} key="1">
              <div className="px-6 pb-6">
                {!loading ? (
                  <AllApprovalsTable
                    data={allData}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={allPage}
                    setAllPage={(num) => setAllPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32  text-center">Pending</div>}
              key="2"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <PendingApprovalsTable
                    data={pendingData}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={pendingPage}
                    setPendingPage={(num) => setPendingPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center ">Approved</div>}
              key="3"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <ApprovedApprovalsTable
                    data={approvedData}
                    changePage={(num) => changeTablePage(num)}
                    current={approvedPage}
                    setApprovedPage={(num) => setApprovedPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Rejected</div>}
              key="4"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <RejectedApprovalsTable
                    data={rejectedData}
                    changePage={(num) => changeTablePage(num)}
                    current={rejectedPage}
                    setRejectedPage={(num) => setRejectedPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Content>

      <ApprovalsFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => filterApproval(values, 1)}
        filterBy={filterBy}
        filterStatus={filterStatus}
      />
    </>
  );
}

export default Approvals;
